module.exports = __webpack_public_path__ + "static/media/m-multipangpang.4ea080a9.png";